module.exports = __webpack_public_path__ + "static/media/CompOffLeave.3bb8b9c0.svg";